import { defineComponent as _defineComponent } from 'vue'
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import WidgetContainer from '../Charts/widgetContainer/WidgetContainer.vue';
import { WidgetEnum } from '@/models/enums/WidgetEnum';
import { dateRangeToDateStrings } from '@/utils/dates';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import HealthIndicatorsContainer from '@/components/careConsole/HealthIndicatorsContainer.vue';
import LayoutGrid from '@/views/dashboard/LayoutGrid.vue';
import { LayoutSlot } from '@/views/dashboard/layout-grid';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Health',
  props: {
    dateRange: null,
    deviceId: null,
    timeAxisSpan: null
  },
  setup(__props: any) {

const props = __props as {
  dateRange: [Date, Date];
  deviceId: string;
  timeAxisSpan: FilterTimeAxisSpanEnum;
};



const gridLayout: LayoutSlot[] = [
  { column: 0, row: 0, width: 8, height: 8 },
  { column: 8, row: 0, width: 4, height: 8 },
];

const healthTimelineWidgetDefinition = computed<WidgetDefinition>(() =>
  new WidgetDefinition(
    WidgetEnum.CareHealthTimeline,
    props.deviceId,
    dateRangeToDateStrings(props.dateRange),
    [],
    undefined,
    props.timeAxisSpan,
  ).hideTitle(),
);

const healthIndicatorsWidgetDefinition = computed<WidgetDefinition>(() =>
  new WidgetDefinition(
    WidgetEnum.CareHealthIndicators,
    props.deviceId,
    dateRangeToDateStrings(props.dateRange),
  ).hideTitle(),
);

return { __sfc: true,props, gridLayout, healthTimelineWidgetDefinition, healthIndicatorsWidgetDefinition, WidgetContainer, HealthIndicatorsContainer, LayoutGrid }
}

})